export default __webpack_public_path__ + "static/media/gcreno-thumb.0f3dcd36.jpeg";